// Feature 011 (FR-047) — defensive empty state when an editor with zero grants
// reaches /data-editing despite the nav-link gating and route guards.
export function EmptyState() {
  return (
    <div className="bg-card rounded-lg shadow border border-line p-8 text-center">
      <h2 className="text-lg font-semibold text-ink mb-2">No data-editing features yet</h2>
      <p className="text-sm text-ink-soft">
        You don't have access to any data-editing features yet — contact the site administrator.
      </p>
    </div>
  );
}
